import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { ECadastralFieldsNames } from '../../types/reducers/rosreestrData';

export const SET_CADASTRAL_FIELD_REQUIRED = 'CADASTRAL_FIELD :: SET_REQUIRED';

interface IRequiredPayload {
  key: ECadastralFieldsNames;
  value: boolean;
}

export type TSetCadastralFieldRequiredAction = IReduxAction<typeof SET_CADASTRAL_FIELD_REQUIRED, IRequiredPayload>;

export const setCadastralFieldRequired = actionGenerator<typeof SET_CADASTRAL_FIELD_REQUIRED, IRequiredPayload>(
  SET_CADASTRAL_FIELD_REQUIRED,
);
